import React, {useState, useEffect} from 'react';

import {patchPayload} from '../lib/misc';
// import Button from "../components/Button";
import Modal from '../components/Modal';
import Spike from './KYC/Spike';
import Esign from './Esign/index';

function ModalEsign(props) {
  const {id, header, patchHandler, status, data, ...restProps} = props;
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [iframeMethodType, setIframeMethodType] = useState('');

  useEffect(() => {
    if (btnDisabled === false) {
      patchHandler(patchPayload(iframeMethodType, status), true);
      setBtnDisabled(true);
    }
  }, [btnDisabled, status, patchHandler, iframeMethodType]);

  return (
    <Modal id={id} header={header} width="max-w-lg" allowClose={false}>
      {data.signing_service_provider === 'certsign' ? (
        <Esign
          {...restProps}
          status={status}
          setBtnDisabled={setBtnDisabled}
          setIframeMethodType={setIframeMethodType}
        />
      ) : (
        <Spike
          {...restProps}
          data={data}
          status={status}
          setBtnDisabled={setBtnDisabled}
          setIframeMethodType={setIframeMethodType}
        />
      )}

      {/*<div className="pt-6 text-right">*/}
      {/*  <Button*/}
      {/*    customProps={{ disabled: btnDisabled }}*/}
      {/*    onClick={submitIframe}*/}
      {/*    color="orange"*/}
      {/*    border={false}*/}
      {/*    title={t`Continue`}*/}
      {/*  />*/}
      {/*</div>*/}
    </Modal>
  );
}

export default ModalEsign;
